import { Badge } from '@app/shared/ui/atoms/Common';

interface TagsProps {
  tags: string[];
}

export function Tags({ tags }: TagsProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {tags.map((tag, index) => (
        <Badge key={`${tag}__${index}`}>{tag}</Badge>
      ))}
    </div>
  );
}
